'use client';

import React, { useEffect, useRef } from 'react';
import Link from 'next/link';

const pains = [
  {
    title: 'The replies read as automated because they were',
    body: 'Scraped-profile personalization sounds specific and lands generic. Prospects deleted it, and reply rates for pure automation sat at 3 to 5%.',
  },
  {
    title: 'Your email reputation took the damage',
    body: 'Unsupervised automated volume taught inboxes to distrust your messages. We rebuild trust with careful, human-paced outreach, and we lead with the phone, where reputation resets with every conversation.',
  },
  {
    title: 'Objections ended the conversation',
    body: 'The moment a prospect pushed back, the thread died. No tool handles a live objection. A trained rep on the phone is where the meeting actually gets won.',
  },
];

export default function SolutionHero() {
  const rightRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    const els = rightRef?.current?.querySelectorAll('.rev');
    els?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <header
      className="py-24"
      style={{
        background:
          'radial-gradient(900px 500px at 85% -10%, rgba(201,137,65,0.15), transparent 60%), var(--navy-deep)',
      }}
    >
      <div className="max-w-site mx-auto px-7">
        <div className="grid grid-cols-1 lg:grid-cols-[1.15fr_0.85fr] gap-16 items-start">
          <div>
            <div className="inline-flex font-mono text-[12px] tracking-[0.18em] uppercase text-primary border border-primary/50 px-4 py-2 rounded-full mb-6">
              For teams replacing an AI SDR
            </div>
            <h1 className="heading-land text-white">The pipeline problem outlasted the tool</h1>
            <p className="mt-5 text-[19px] text-muted-cream leading-relaxed max-w-[56ch]">
              You bought an AI SDR. The demo was incredible, the replies were not, and the churn data says you have company. The budget line still exists. Point it at humans who pick up the phone.
            </p>
            <div className="flex flex-wrap gap-3.5 mt-9">
              <a
                href="/request-meeting"
                className="inline-flex items-center gap-2.5 font-semibold text-sm px-6 py-3.5 rounded-[10px] bg-primary text-navy-deep border border-transparent transition-all duration-200 hover:bg-gold-bright hover:-translate-y-px hover:shadow-gold"
              >
                Book a replacement call
              </a>
              <Link
                href="/pricing"
                className="inline-flex items-center gap-2.5 font-semibold text-sm px-6 py-3.5 rounded-[10px] border border-line-navy text-white transition-all duration-200 hover:border-primary hover:text-primary"
              >
                See pricing
              </Link>
            </div>
          </div>

          <div ref={rightRef} className="pt-4">
            {pains?.map((p, i) => (
              <div
                key={p?.title}
                className="rev pain-item"
                style={{ transitionDelay: `${i * 0.1}s` }}
              >
                <b className="block text-[16.5px] mb-1 text-white font-semibold">{p?.title}</b>
                <p className="text-[15px] text-muted-cream leading-relaxed">{p?.body}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
}